import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import { Link } from 'react-router';
import styles from './CategorizedSideNav.scss';

const CategorizedSideNav = ({ categories, activeLink, setActiveLink }) => {
    const [selectedLink, setSelectedLink] = useState(activeLink);

    useEffect(() => {
        setSelectedLink(activeLink);
    }, [activeLink]);

    const handleLinkClick = (link, event) => {
        event.preventDefault();
        setSelectedLink(link.to);
        setActiveLink(link.to);
        window.history.pushState({}, '', link.to);
    };

    return (
        <nav className={styles.sidebar} data-cy="CategorizedSideNav">
            {categories.map((category, categoryIndex) => (
                <div key={categoryIndex} className={`${styles.categoryContainer} ${categoryIndex && styles.category}`}>
                    <h1 className={styles.categoryHeader}>{category.title}</h1>
                    {/* <hr style={{ marginRight: '0.71429rem' }} /> */}
                    {category.links.map((link, linkIndex) => (
                        <div key={linkIndex} className={styles.entry}>
                            <Link
                                to={link.to}
                                className={classnames(styles.link,
                                    { [styles.active]: selectedLink === link.to, [styles.inactive]: selectedLink !== link.to, })
                                }
                                onClick={(event) => handleLinkClick(link, event)}
                            >
                                {link.title}
                            </Link>
                        </div>
                    ))}
                </div>
            ))}
        </nav>
    );
};

export default CategorizedSideNav;